/**
 * GET /user/get_team_section — parse teamSection rows + sum totals.
 */
export function parseTeamSectionResponse(res) {
  const data = res?.data ?? res;
  return {
    teamSection: data?.teamSection ?? [],
    teamSum: data?.sum ?? null,
  };
}
